import React from 'react'
import SafetySection from '../../components/SafetyManagement/SafetySection'
import ReviewSection from '../../components/SafetyManagement/ReviewsSection'

const SafetyPage = () => {
  return (
    <div>
        <SafetySection/>
        <ReviewSection/>
    
    </div>
  )
}

export default SafetyPage